import { createGlobalStyle, css } from 'styled-components';
import { reset } from '@/styles/reset';
import { toastifyOverride } from '@/styles/toastify';

export const GlobalStyle = createGlobalStyle`
    ${reset}

    body {
        ${({ theme }) => css`
          background: ${theme.colors.grayBackground};
          color: ${theme.colors.gray};
        `};

        -webkit-font-smoothing: antialiased;
    }

    body, input, textarea, button {
        font-family: ${({ theme }) => theme.fonts.Poppins};
        font-style: normal;
        font-weight: 400;
    }
    
    p {
        line-height: 1.4;
    }
    
    p a {
        font-weight: 600;
        color: ${({ theme }) => theme.colors.saturatedBlue};
        text-decoration: underline;
        transition: .3s;
        
        @media (hover: hover) {
            &:hover {
                opacity: .7;
            }
        }
    }
    .crisp-hidden {
        display: none;
    }

    p, h1, h2, h3, h4, h5, h6, label, a {
        letter-spacing: 0.3px;
    }
    
    ${toastifyOverride}
`;
